module.exports = __webpack_public_path__ + "components/buttons/static/surf-forecast__logo-5490895c38b60a7b4d391e12479ef725.svg";